import React from 'react';
import PropTypes from 'prop-types';
import {
  useIntl,
  defineMessages,
} from 'react-intl';
import { Box } from '@mui/material';

export const App = ({children}) => {
  const t = defineMessages({
    'app.document.title': {
      id: 'app.document.title',
      defaultMessage: 'Client Management Portal',
      description: 'The document title of the application (appears in browser tab)',
    },
  });

  const intl = useIntl();
  document.title = intl.formatMessage(t['app.document.title']);
  return (
    <Box>
      {children}
    </Box>
  );
};

App.propTypes = {
  children: PropTypes.element.isRequired,
};

export default App;
